module.exports = __webpack_public_path__ + "static/media/stobart-group-logo-charcoal.26a412c7.svg";